export default __webpack_public_path__ + "static/media/plug.02b4edf2.png";